import DesktopMenuItems from '../DesktopMenuItems';
import DesktopWorkflowTopBarMenuItemsContainer from '../../../containers/DesktopWorkflowTopBarMenuItemsContainer';

export const LEVEL_TWO = DesktopMenuItems;
export const LEVEL_ONE = DesktopWorkflowTopBarMenuItemsContainer;